import React from "react";
import styled from "styled-components";
import SidebarComponent from "./SidebarComponent";
import basketicon from "../../Images/basketicon.svg";
import { SIDEBAR_OPTIONS_LIST } from "../../utilities/constants";

const Sidebar = () => {
  return (
    <>
      <img
        src={basketicon}
        style={{ maxWidth: 110, objectFit: "contain" }}
        alt="Menu_icon"
        className="menu_icon"
      />
      <StyledSidebar className="pb-5 mb-5">
        <SidebarDiv>
          <SidebarComponent
            optionsList={SIDEBAR_OPTIONS_LIST}
            nestingLevel={0}
          />
        </SidebarDiv>
      </StyledSidebar>
    </>
  );
};

export default Sidebar;

const StyledSidebar = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #ffffff;
`;
const SidebarDiv = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  justify-content: flex-start;
  margin-top: 40px;
`;
